// Información de build generada automáticamente
export const BUILD_DATE = '05-03-2026 18:43:27';
export const BUILD_HASH = 'm1j41t1xjm';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1772747007771;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '05-03-2026 18:43:27',
  buildHash: 'm1j41t1xjm',
  appVersion: '0.0.0',
  timestamp: 1772747007771
});
